// extracted by mini-css-extract-plugin
export default {"actionSlot":"MoreInfoButton_actionSlot__8PEmH","button":"MoreInfoButton_button__f3GTy"};